module.exports = __webpack_public_path__ + "static/media/20_l_lamp_19.32_0.c98def0f.png";